module.exports = __webpack_public_path__ + "static/heroes_logo_full_ru-f346e61b95cf2ef6f77637528f51cb9d.svg";